import { Button } from "@mui/material";
import { useModalState } from "@src/lib/ui-react";

import { RequirementMappingDialog } from "./RequirementMappingDialog";

interface AddRequirementMappingDialogProps {
  hcfId?: string;
}

export function AddRequirementMappingDialog(props: AddRequirementMappingDialogProps) {
  const { hcfId } = props;
  const modalState = useModalState();

  return (
    <>
      <Button variant="contained" color="primary" onClick={modalState.openModal}>
        Add Mapping
      </Button>
      {modalState.modalIsOpen && <RequirementMappingDialog modalState={modalState} hcfId={hcfId} />}
    </>
  );
}
